import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from ".";

export interface UploadedArtworkData {
  imageAmazonS3URL?: string;
  aiMentorReview?: number;
  aiMentorDescription?: string;
  category?: string;
  tags?: string[];
  id?: string;
  slot?: "free" | "votes" | "battles" | "nfts" | "invites" | "paid";
}

const initialState: UploadedArtworkData = {};

const artworkSlice = createSlice({
  name: "artwork",
  initialState,
  reducers: {
    setArtwork(artworkState, { payload }: PayloadAction<UploadedArtworkData>) {
      artworkState.imageAmazonS3URL = payload.imageAmazonS3URL;
      artworkState.aiMentorReview = payload.aiMentorReview;
      artworkState.aiMentorDescription = payload.aiMentorDescription;
      artworkState.category = payload.category;
      artworkState.tags = payload.tags;
      artworkState.id = payload.id;
      artworkState.slot = payload.slot;
    },
  },
});

export const { setArtwork } = artworkSlice.actions;

export const artworkState = createSelector(
  (state: RootState) => state.artwork,
  (artworkState): UploadedArtworkData => {
    return artworkState;
  }
);

export default artworkSlice.reducer;
